import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DiscountWidgets from 'app/pages/DiscountEditor/components/DiscountWidgets';
import SaveAndBackButtons from 'app/pages/DiscountEditor/components/SaveAndBackButtons';
import WarnOnUnsavedChanges from 'app/pages/DiscountEditor/components/WarnOnUnsavedChanges';
import { loadPage } from 'app/pages/DiscountEditor/loadPage';
import { PublishedEventType, useSignalREvent } from 'app/helpers/signalRHelper';
import type { QueryParamsMap } from 'app/RouteDefinition';

import "./Page.css";

function toQueryParamsMap(search: string): QueryParamsMap {
  const qs: QueryParamsMap = {};
  const sp = new URLSearchParams(search || '');
  sp.forEach((value, key) => {
    qs[key] = value;
  });
  return qs;
}

export function Page() {
  const dispatch = useDispatch<any>();
  const location = useLocation();

  const queryParams = React.useMemo(
    () => toQueryParamsMap(location.search),
    [location.search]
  );

  const queryParamsRef = React.useRef<QueryParamsMap>(queryParams);
  React.useEffect(() => {
    queryParamsRef.current = queryParams;
  }, [queryParams]);

  const refreshGridEvent = React.useCallback(async () => {
    // Reload the editor data (discount + lookup lists) using the same querystring.
    await loadPage(dispatch, queryParamsRef.current);
  }, [dispatch]);

  useSignalREvent([PublishedEventType.DiscountEventPublished], refreshGridEvent);

  return (
    <div>
      <SaveAndBackButtons />
      <DiscountWidgets />
      <WarnOnUnsavedChanges />
    </div>
  );
}

